export default function getXlsxColumnsWidth(input) {
  const base = 'Z'.charCodeAt(0) - 'A'.charCodeAt(0) + 1;
  const letterAValue = 'A'.charCodeAt(0);

  if (input.length > 1) {
    const letters = input.split('');
    return letters.reduce((acc, letter) => acc * base + (letter.charCodeAt(0) - letterAValue + 1), 0);
  }
  return input.charCodeAt(0) - 'A'.charCodeAt(0) + 1;
}
